// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfUse_root__3wmmn","section":"TermsOfUse_section__2l-it"};